import { Component } from '@angular/core';

@Component({
  selector: 'nested-angularjs',
  templateUrl: './nested-angularjs.component.html',
  //styleUrl: './nested-angularjs.component.scss'
})
export class NestedAngularjsComponent {
  count = 0;
  exampleParam = 'Example param provided by Angular'


  onCountClick(shouldCount: boolean): void {
    if(shouldCount)
      this.count += 1;
  }

}
